import { useEffect, useMemo, useState } from 'react'

type NavUserAvatarProps = {
  src?: string | null
  label?: string
  className?: string
}

export default function NavUserAvatar({
  src,
  label = '?',
  className = 'h-10 w-10',
}: NavUserAvatarProps) {
  const [loadFailed, setLoadFailed] = useState(false)
  const cleanSrc = String(src || '').trim()

  useEffect(() => {
    setLoadFailed(false)
  }, [cleanSrc])

  const initial = useMemo(() => {
    const value = String(label || '?').trim()
    return (value.charAt(0) || '?').toUpperCase()
  }, [label])

  if (cleanSrc && !loadFailed) {
    return (
      <img
        src={cleanSrc}
        alt={label || 'Me'}
        className={`${className} rounded-full object-cover`}
        onError={() => setLoadFailed(true)}
      />
    )
  }

  return (
    <div className={`${className} rounded-full flex items-center justify-center text-sm font-semibold text-white/85`}>
      {initial}
    </div>
  )
}

